import React from 'react'
import HomeArmaTuPc from '../components/armaTuPc/HomeArmaTuPc'

function ArmaTuPc({
  addToCart,
  shopItems,
  productItems
}) {
  return (
    <HomeArmaTuPc addToCart={addToCart} shopItems={shopItems} productItems={productItems}/>
  )
}


export default ArmaTuPc